import type {
	ComponentProps,
	ComponentPropsWithoutRef,
	ElementRef,
} from 'react'
import { forwardRef } from 'react'
import { Button, buttonVariants } from '@cocoonspace/ui/components/button'
import { TitleDivider } from '@cocoonspace/ui/components/cocoon/title-divider'
import { cn } from '@cocoonspace/ui/lib/utils'
import { LocalizedLink as Link } from '~/components/localized-link'

export const SectionWrapper = ({
	className,
	...props
}: ComponentProps<'div'>) => {
	return (
		<div
			className={cn('flex flex-col gap-4 p-4', className)}
			{...props}
		/>
	)
}

export const SectionTitle = ({
	className,
	...props
}: ComponentProps<'div'>) => {
	return (
		<div className='flex flex-col gap-1'>
			<div
				className={cn('flex items-center gap-2 text-sm font-bold', className)}
				{...props}
			/>

			<TitleDivider size='sm' />
		</div>
	)
}

type SectionTitleBtnProps = ComponentPropsWithoutRef<typeof Button> & {
	href?: string
}

type SectionTitleBtnRef = ElementRef<typeof Button>

export const SectionTitleBtn = forwardRef<
	SectionTitleBtnRef,
	SectionTitleBtnProps
>(({ className, href, ...props }, ref) => {
	if (href) {
		return (
			<Link
				href={href}
				target='_blank'
				className={buttonVariants({
					variant: 'link',
					size: 'sm',
					className: cn('ml-auto gap-1 [&>svg]:!size-3', className),
				})}
			>
				{props.children}
			</Link>
		)
	}

	return (
		<Button
			ref={ref}
			variant='link'
			size='sm'
			className={cn('ml-auto gap-1 [&>svg]:!size-3', className)}
			{...props}
		/>
	)
})

SectionTitleBtn.displayName = 'SectionTitleBtn'

export const NoContent = ({ className, ...props }: ComponentProps<'div'>) => {
	return (
		<div
			className={cn('text-muted-foreground text-center text-sm', className)}
			{...props}
		/>
	)
}
